import React from 'react';

interface SelectionBoxProps {
  isVisible: boolean;
  selectionBox: {
    startX: number;
    startY: number;
    width: number;
    height: number;
  };
}

const SelectionBoxOverlay: React.FC<SelectionBoxProps> = ({
  isVisible,
  selectionBox,
}) => {
  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'absolute',
        left: Math.min(
          selectionBox.startX,
          selectionBox.startX + selectionBox.width
        ),
        top: Math.min(
          selectionBox.startY,
          selectionBox.startY + selectionBox.height
        ),
        width: Math.abs(selectionBox.width),
        height: Math.abs(selectionBox.height),
        border: '2px solid #1890ff',
        backgroundColor: 'rgba(24, 144, 255, 0.1)',
        pointerEvents: 'none', // Allows clicking through the selection box
        zIndex: 999, // Ensure it's above canvas content
      }}
    />
  );
};

export default SelectionBoxOverlay;
